import React from 'react'
import {
  AlignItems,
  Box,
  Color,
  Display,
  DisplayPosition,
  FontWeight,
  Heading3,
  Image,
  JustifyContent,
  Overflow,
  Text,
} from '@gousto-internal/citrus-react'
import { getDefaultImage, getSrcSet } from '../../utils'

export type CategoryTileProps = {
  title: string
  imageCrops?: {
    url: string
    width: number
  }[]
  recipeCount: number
  onClick: () => void
}

export const CategoryTile = ({
  title,
  imageCrops = [],
  recipeCount,
  onClick,
}: CategoryTileProps) => {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      onClick()
    }
  }

  return (
    <Box
      display={Display.Flex}
      justifyContent={JustifyContent.SpaceBetween}
      bg={Color.White}
      width={['170px', '225px', '366px']}
      height={['85px', '85px', '133px']}
      role="button"
      tabIndex={0}
      style={{ cursor: 'pointer', borderRadius: '4px' }}
      onClick={onClick}
      onKeyDown={handleKeyDown}
    >
      <Box paddingH={2} paddingV={2}>
        <Heading3 color={Color.ColdGrey_900} fontWeight={FontWeight.Bold} size={[2, 2, 6]}>
          {title}
        </Heading3>
      </Box>

      <Box
        position={DisplayPosition.Relative}
        width={['80px', '80px', '149px']}
        height="100%"
        overflowX={Overflow.Hidden}
        flexShrink={0}
      >
        <Image
          src={getDefaultImage(imageCrops)}
          srcSet={getSrcSet(imageCrops)}
          alt={title}
          height="100%"
          width="100%"
          fit="cover"
          style={{
            borderTopRightRadius: '4px',
            borderBottomRightRadius: '4px',
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
          }}
        />
        <Box
          position={DisplayPosition.Absolute}
          bg={Color.ColdGrey_50}
          style={{ borderRadius: '4px' }}
          display={Display.Flex}
          alignItems={AlignItems.Center}
          justifyContent={JustifyContent.Center}
          paddingV={0.5}
          paddingH={1}
          bottom={['4px', '4px', '7px']}
          right={['4px', '4px', '7px']}
        >
          <Text color={Color.ColdGrey_800} fontWeight={FontWeight.Bold} size={[0, 0, 1]}>
            {recipeCount}
          </Text>
        </Box>
      </Box>
    </Box>
  )
}
